import React from "react";
import "./panazCreative.css";

function PanazCreative() {
  return (
    <React.Fragment>
      <div className="ad-728x90">
        <div className="ad-content">
          <div className="ad-info1">
            <div className="ad-info-content">
              <p className="ad-info-text">
                Do you have patients with myelofibrosis
                <br />
                who are not responding to treatment?
              </p>
              <div className="btn-wrap">
                <a className="cta button1" id="cta">
                  Know More
                </a>
                <span>A clinical study is enrolling near you</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PanazCreative;
